export default __webpack_public_path__ + "dcc404bdb6b52477242399fca290b6c0.svg";